'use client';

import { PropsWithChildren, useState } from 'react';

import { ThemesNames } from '~types/Theme.types';

import { ThemeContext } from './ThemeContext';

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const [theme, setTheme] = useState<ThemesNames>(ThemesNames.White);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
